import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {catchError, debounceTime, distinctUntilChanged, map, tap, switchMap} from 'rxjs/operators';
import { environment } from './../../../../src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ApiServiceService {

  constructor(private http:HttpClient) { }
  headers = new HttpHeaders().set('content-type', 'application/json')
  API_KEY = environment.API_KEY

  URL_1 = environment.Vessel_Tracker_URL_1;
  URL_2 = environment.Vessel_Tracker_URL_2;

  search(term: string) {
    if (term === '') {
      return of([]);
    }
    return this.http
      .post(this.URL_1,  {
        API_KEY: this.API_KEY,
        term: term
     }).pipe(
        map(response => response)
      );
  }
  getContainerVesselTrackerDetails(obj:any):Observable<any>{
    obj.API_KEY = this.API_KEY;
    return  this.http.post(this.URL_2,obj);
  }
 
}
